import type { FaireProductEntity } from "../../entity_types/product";

export const p_cpshpwwjqd: FaireProductEntity = {
  token: "p_cpshpwwjqd",
  type: "product",
  name: "Sunny Non-Tarnish Boho Color Beaded Necklace",
  brandToken: "b_3tzh9mjdm6",
  brandName: "Flânerie by MAIQ",
  imageUrl:
    "https://cdn.faire.com/fastly/81f027862106268f7dbedee6121bfab8a1a82c14aa2707a23660d5e1e25495dd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/90f598270601bb3055f0e399d9cdef888d4608656b0e8dfcc1cb4b663f894ae8.jpeg",
    "https://cdn.faire.com/fastly/a09a462524d40521e231509568518d77ad3615f73212b6afb11db4b126cf1e2f.jpeg",
    "https://cdn.faire.com/fastly/7a5545eda76985efea1daeec998362db9029cf9e53e0037997c6012d3e321e72.jpeg",
    "https://cdn.faire.com/fastly/c0fa4fb03e32d06df0444afc5bd98dd509c3233473886c863f3940242c89d003.jpeg",
  ],
  priceDollars: 10.99,
  description:
    "Non-Tarnish Boho Color Beaded Necklace\n• Stainless Steel\n• Natural stones & Pearls\n• Chain Length (inch): 15\n• Extension Length (inch): 2\n• Lead-free, Nickel-safe\n• Hypoallergenic\n• Water Resistant",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:05.253Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
